import React,{useMemo} from "react";
import Helper from "../functions/Helper.js";
/** @jsx jsx */
import {jsx} from '@emotion/core'

function Popup (props){
  let {shoe,colorways_by_shop}=props;
  let picture=shoe.pictures[1];
  return (
    <div style={{backgroundColor:"#fff"}}>
      <button style={{fontSize:50,padding:"10px 25px 25px 25px"}}
        className="close" type="button" data-dismiss="modal" aria-label="Close"
        onClick={()=>{props.hideModal()}}>
        <span aria-hidden="true">&times;</span>
      </button>
      <div css={{padding:20,"@media (min-width:576px)":{padding:30}}}>
        <div style={{fontSize:24,lineHeight:"1.2",padding:"0px 30px 10px 0px",fontWeight:"600"}}>
          Deals for {shoe.shoe_name}
        </div>
        <img loading="lazy" style={{maxWidth:250,width:"100%",padding:"30px 0px",transform: picture.mirror==="1" && "scaleX(-1)"}} alt={shoe.shoe_name} sizes="250px" srcSet={Helper.create_source_set(picture)}/>
        <div style={{paddingTop:20}}>
          {colorways_by_shop.map((colorways,index)=>{
            let discount=Math.round((1-(colorways.colorways[0].price_discount/colorways.colorways[0].list_price))*100);
            let colorway=colorways.colorways[0];
            return(
              <div style={{display:"flex",flex:1,flexDirection:"row",padding:"8px 0px",borderTopWidth:1,borderBottomWidth:index===colorways_by_shop.length-1 ? 1:0,borderColor:"#f0f0f0",borderStyle:"solid"}} key={colorway.colorway_id} >
                <div style={{display:"flex",flexDirection:"column",justifyContent:"center"}}>
                  <div>
                    <div style={{color:"#333333",fontSize:16,lineHeight:1.3,fontWeight:500}}>
                    {colorway.shop_name}
                    </div>
                  </div>
                  <div style={{display:"flex",marginTop:2,lineHeight:1.3,flexDirection:"row"}}>
                    <div style={{fontWeight:"600",color:discount>1 ? "#e32b2b" :"black"}}>
                      ${colorway.price_discount}
                    </div>
                    {discount>1 &&
                      <div style={{color:"#767676",textDecorationLine:"line-through",textDecorationStyle: 'solid',marginLeft:5}}>
                        ${Math.round(Number(colorway.list_price))}
                      </div>
                    }
                  </div>
                </div>
                <div style={{display:"flex",flexDirection:"column",flex:1,justifyContent:"center",alignItems:"flex-end"}}>
                  <a target="_blank" rel="noopener nofollow" href={Helper.insert_link(colorway.link_url, props.prefix + "_popup_button",colorway.tracking_id)}
                    css={{":hover":{textDecoration:"none",color:"white"},color:"white",fontWeight:"700",borderRadius:2,padding:"8px 30px",fontSize:16,backgroundColor:"#FF5A5F",}}>
                    Buy Now
                  </a>
                </div>
            </div>
            )}
            )}
        </div>


          <div style={{marginTop:30,fontSize:12}}>
            These links are affiliate links, meaning, at no additional cost to you, we will earn a commission if you click through and make a purchase.
            Prices last updated on {props.lastUpdate}
          </div>
        </div>
      </div>
    );
}

export default Popup;
